// =============================================================================
// LIVE VOICE TYPES AND DATA
// =============================================================================

/**
 * Live voice interface for character voice selection
 */
export interface LiveVoice {
  id: string;
  name: string;
  gender: string;
  audio_url: string;
}

/**
 * Centralized live voice data - contains all available live voices
 */
export const AVAILABLE_LIVE_VOICES: LiveVoice[] = [
  // Female live voices
  {
    id: "Aoede",
    name: "Amy",
    gender: "female",
    audio_url: "/live_voices/female/Aoede.wav"
  },
  {
    id: "Gacrux",
    name: "Gwen",
    gender: "female",
    audio_url: "/live_voices/female/Gacrux.wav"
  },
  {
    id: "Kore",
    name: "Kate",
    gender: "female",
    audio_url: "/live_voices/female/Kore.wav"
  },
  {
    id: "Sulafat",
    name: "Sara",
    gender: "female",
    audio_url: "/live_voices/female/Sulafat.wav"
  },

  // Male live voices
  {
    id: "Algenib",
    name: "Alex",
    gender: "male",
    audio_url: "/live_voices/male/Algenib.wav"
  },
  {
    id: "Charon",
    name: "Charlie",
    gender: "male",
    audio_url: "/live_voices/male/Charon.wav"
  },
  {
    id: "Enceladus",
    name: "Chris",
    gender: "male",
    audio_url: "/live_voices/male/Enceladus.wav"
  },
  {
    id: "Puck",
    name: "Paul",
    gender: "male",
    audio_url: "/live_voices/male/Puck.wav"
  }
];
